// src/pages/HRAdmin/Position/AddPositionPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper
} from '@mui/material';

function AddPositionPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    description: '',
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .post('/positions', formData)
      .then(() => navigate('/admin/positions'))
      .catch((err) => console.error('Error creating position:', err));
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Add New Position
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Position Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          fullWidth
          margin="normal"
        />
        <TextField
          label="Code"
          name="code"
          value={formData.code}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => navigate('/admin/positions')}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Save
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}

export default AddPositionPage;
